import qs from 'qs'

import ElementUI from 'element-ui';

import store from '../store'
import router from '../router'

// config
axios.defaults.timeout = 500000
// axios.defaults.headers.post['Content-Type'] = 'application/json;'
axios.defaults.baseURL = 'http://oaapi.xswater.cn'
// axios.defaults.baseURL = 'http://172.16.10.38:8090'


// trim 字符串
function myTrim(x) {
  return x.replace(/^\s+|\s+$/gm, '');
}

// 请求/响应拦截
axios.interceptors.request.use(function (config) {
    // 处理请求accesstoken
    if (store.state.main.userData && store.state.main.userData.accesstoken) {
      config.headers.accesstoken = store.state.main.userData.accesstoken
    }

    // 循环trim处理（去除前后空格）
    for (var key in _data) {
      _data[key] = myTrim(_data[key])
    }


    // 处理请求数据 是否需要 stringify
    // if (!config.url.toLowerCase().match('/conference/summary/add') && !config.url.toLowerCase().match('/conference/summary/edit') && !config.url.toLowerCase().match('/storage/material/in') && !config.url.toLowerCase().match('/storage/material/allot') && !config.url.toLowerCase().match('/storage/material/use') && !config.url.toLowerCase().match('/storage/material/back') && !config.url.toLowerCase().match('/storage/material/use/edit')) {

    let _data = config.data
    if (_data && _data.json) {
      // 使用json传输，不需额外处理
    } else {
      _data = qs.stringify(config.data)
    }


    config.data = _data
    return config;
  },
  function (error) {
    return Promise.reject(error);
  });

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // console服务器返回的数据
  console.log(response.config.url + ' ------>', response.data)

  let _data = response.data
  // 错误自动跳转到登录页
  if (_data.code != 20000) {
    switch (_data.code) {
      case 30006:
      case 30007:
        return false
        break;
      case 30003:
        ElementUI.Message.error("请先登录")
        // router.push("/")
        store.commit('set_loginPopState', true)
        break;
      case 30010:
        break;
      default:
        ElementUI.Message.error(_data.msg)
        break;
    }
  }
  return response.data;
}, function (error) {
  // window.localStorage.removeItem('userData')
  console.log(error)
  ElementUI.Message.error('请求失败，请联系管理员，错误内容：' + error)
  return Promise.reject(error);
});

window.ajax = {
  get(url, data, cb, failCb) {
    axios.get(url, {
      params: data
    }).then((res) => {
      if (res.code == 20000) {
        cb && cb(res)
      } else {
        // if(res.code == 30003){

        // }

        failCb && failCb(res)
        console.log('error')

      }
    }).catch(function (error) {
      ElementUI.Message.error('系统发生未知错误，请联系管理员，错误内容：' + error)
      failCb && failCb()
      console.log(error);
    });
  },
  post(url, data, cb, failCb) {
    axios.post(url, data)
      .then((res) => {
        if (res.code == 20000) {
          cb && cb(res)
        } else {
          if (failCb) {
            failCb && failCb(res)
          } else {
            switch (res.code) {
              case 30006:
              case 30007:
                return false
                break;
              case 30010:
                break;
              default:
                ElementUI.Message.error(res.msg)
                break;
            }
          }
          console.log('error')
        }
      }).catch(function (error) {
        ElementUI.Message.error('系统发生未知错误，请联系管理员，错误内容：' + error)
        failCb && failCb()
        console.log(error);
      });
  }
}


// 其他公用函数方法
window.util = {
  convertCurrency(currencyDigits) {
    // Constants: 
    var MAXIMUM_NUMBER = 99999999999.99;
    // Predefine the radix characters and currency symbols for output: 
    var CN_ZERO = "零";
    var CN_ONE = "壹";
    var CN_TWO = "贰";
    var CN_THREE = "叁";
    var CN_FOUR = "肆";
    var CN_FIVE = "伍";
    var CN_SIX = "陆";
    var CN_SEVEN = "柒";
    var CN_EIGHT = "捌";
    var CN_NINE = "玖";
    var CN_TEN = "拾";
    var CN_HUNDRED = "佰";
    var CN_THOUSAND = "仟";
    var CN_TEN_THOUSAND = "万";
    var CN_HUNDRED_MILLION = "亿";
    var CN_SYMBOL = ""; //人民币:  前缀，暂时不加
    var CN_DOLLAR = "元";
    var CN_TEN_CENT = "角";
    var CN_CENT = "分";
    var CN_INTEGER = "整";

    // Variables: 
    var integral; // Represent integral part of digit number. 
    var decimal; // Represent decimal part of digit number. 
    var outputCharacters; // The output result. 
    var parts;
    var digits, radices, bigRadices, decimals;
    var zeroCount;
    var i, p, d;
    var quotient, modulus;

    // Validate input string: 
    currencyDigits = currencyDigits.toString();
    if (currencyDigits == "") {
      alert("请输入小写金额！");
      return "";
    }
    if (currencyDigits.match(/[^,.\d]/) != null) {
      alert("小写金额含有无效字符！");
      return "";
    }
    if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
      alert("小写金额的格式不正确！");
      return "";
    }

    // Normalize the format of input digits: 
    currencyDigits = currencyDigits.replace(/,/g, ""); // Remove comma delimiters. 
    currencyDigits = currencyDigits.replace(/^0+/, ""); // Trim zeros at the beginning. 
    // Assert the number is not greater than the maximum number. 
    if (Number(currencyDigits) > MAXIMUM_NUMBER) {
      alert("金额过大，应小于1000亿元！");
      return "";
    }

    // Process the coversion from currency digits to characters: 
    // Separate integral and decimal parts before processing coversion: 
    parts = currencyDigits.split(".");
    if (parts.length > 1) {
      integral = parts[0];
      decimal = parts[1];
      // Cut down redundant decimal digits that are after the second. 
      decimal = decimal.substr(0, 2);
    } else {
      integral = parts[0];
      decimal = "";
    }
    // Prepare the characters corresponding to the digits: 
    digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
    radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
    bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
    decimals = new Array(CN_TEN_CENT, CN_CENT);
    // Start processing: 
    outputCharacters = "";
    // Process integral part if it is larger than 0: 
    if (Number(integral) > 0) {
      zeroCount = 0;
      for (i = 0; i < integral.length; i++) {
        p = integral.length - i - 1;
        d = integral.substr(i, 1);
        quotient = p / 4;
        modulus = p % 4;
        if (d == "0") {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            outputCharacters += digits[0];
          }
          zeroCount = 0;
          outputCharacters += digits[Number(d)] + radices[modulus];
        }
        if (modulus == 0 && zeroCount < 4) {
          outputCharacters += bigRadices[quotient];
          zeroCount = 0;
        }
      }
      outputCharacters += CN_DOLLAR;
    }
    // Process decimal part if there is: 
    if (decimal != "") {
      for (i = 0; i < decimal.length; i++) {
        d = decimal.substr(i, 1);
        if (d != "0") {
          outputCharacters += digits[Number(d)] + decimals[i];
        }
      }
    }
    // Confirm and return the final output string: 
    if (outputCharacters == "") {
      outputCharacters = CN_ZERO + CN_DOLLAR;
    }
    if (decimal == "") {
      outputCharacters += CN_INTEGER;
    }
    outputCharacters = CN_SYMBOL + outputCharacters;
    return outputCharacters;
  },
  // 是否在数组内
  isInArray(key, arr) {
    let _in = false
    for (let i = 0; i < arr.length; i++) {
      if (key == arr[i]) {
        _in = true
        break;
      }
    }
    return _in
  },
  // 合并数组并去重
  arrConcatUnRepeat(arr1, arr2) {
    let _arr = arr1
    for (let i = 0; i < arr2.length; i++) {
      let _item = arr2[i],
        isrepeat = false
      for (let j = 0; j < arr1.length; j++) {
        if (_item.id == arr1[j].id) {
          isrepeat = true
          break;
        }
      }
      if (!isrepeat) {
        _arr.push(_item)
      }
    }
    return _arr
  },
  // 两位加零
  getTwoChar(c, min) {
    if (c >= min && c <= 9) {
      c = "0" + c;
    }
    return c
  },
  // 时间戳转日期
  getFormatDate(timestamp, type) {
    var date = new Date();
    if (timestamp) {
      date = new Date(timestamp)
    }

    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds()

    month = this.getTwoChar(month, 1)
    strDate = this.getTwoChar(strDate, 0)
    hours = this.getTwoChar(hours, 0)
    minutes = this.getTwoChar(minutes, 0)
    seconds = this.getTwoChar(seconds, 0)

    var currentdate = year + "-" + month + "-" + strDate;
    if (type) {
      currentdate += " " + hours + ':' + minutes + ':' + seconds
    }
    return currentdate;
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js